import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { HttpClientModule } from '@angular/common/http'

import { UtilCommonModule } from 'common/util/module'
import { LocaleModule } from 'common/locale/module'
import { PanelRootComponent } from './components/panelRoot.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild([]),
    LocaleModule.forChild(),
    HttpClientModule,
    NgbTooltipModule,
    UtilCommonModule,
  ],
  declarations: [
    PanelRootComponent,
  ],
  exports: [
    PanelRootComponent,
  ],
})
export class PanelModule { }

export { PanelService } from './services/panel.service'
export { PanelRootComponent }
